<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle :pageTitle="isEditing ? 'Edit Customer' : 'Add Customer'" subTitle="Management" />

    <div class="card bg-white border-0 rounded-3 mb-4">
      <div class="card-body p-4">
        <form @submit.prevent="submitForm">
          <div class="row">
            <div class="col-lg-6 col-md-6 mb-4">
              <label class="form-label text-dark fs-14 fw-medium">Phone Number</label>
              <input type="text" class="form-control" v-model="form.phone_number" placeholder="Enter phone number" required />
            </div>
            
            <div class="col-lg-6 col-md-6 mb-4">
              <label class="form-label text-dark fs-14 fw-medium">Name</label>
              <input type="text" class="form-control" v-model="form.name" placeholder="Enter name" />
            </div>
            
            <div class="col-lg-6 col-md-6 mb-4">
              <label class="form-label text-dark fs-14 fw-medium">Free Tokens</label>
              <input type="number" class="form-control" v-model="form.free_tokens" placeholder="0" min="0" />
            </div>
          </div>
          
          <div class="d-flex justify-content-end gap-2">
            <RouterLink to="/customers" class="btn btn-secondary fs-15 fw-medium">Cancel</RouterLink>
            <button type="submit" class="btn btn-primary fs-15 fw-medium" :disabled="loading">
              <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              {{ isEditing ? 'Update Customer' : 'Create Customer' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import PageTitle from '@/components/Common/PageTitle.vue';
import customerService from '@/services/customerService';

export default defineComponent({
  name: 'CustomerFormPage',
  components: {
    PageTitle
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    
    const isEditing = ref(false);
    const customerId = ref<number | null>(null);
    const loading = ref(false);
    
    const form = ref({
      phone_number: '',
      name: '',
      free_tokens: 0
    });

    onMounted(async () => {
      if (route.params.id) {
        isEditing.value = true;
        customerId.value = Number(route.params.id);
        await fetchCustomer(customerId.value);
      }
    });

    const fetchCustomer = async (id: number) => {
      try {
        const response = await customerService.getById(id);
        const data = response.data;
        form.value = {
          phone_number: data.phone_number,
          name: data.name || '',
          free_tokens: data.free_tokens
        };
      } catch (error) {
        console.error('Error fetching customer:', error);
        router.push('/customers');
      }
    };

    const submitForm = async () => {
      loading.value = true;
      try {
        if (isEditing.value && customerId.value) {
          await customerService.update(customerId.value, form.value);
        } else {
          await customerService.create(form.value);
        }
        router.push('/customers');
      } catch (error) {
        console.error('Error saving customer:', error);
      } finally {
        loading.value = false;
      }
    };

    return {
      isEditing,
      form,
      loading,
      submitForm
    };
  }
});
</script>
